import { render, staticRenderFns } from "./lingid_lisamine.vue?vue&type=template&id=30d8f0c9&"
import script from "./lingid_lisamine.vue?vue&type=script&lang=js&"
export * from "./lingid_lisamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports